export default "__VITE_ASSET__CWIps0Q4__"